import { z } from 'zod';
import { slugSchema, seoSchema } from './common.js';

export const categoryInputSchema = z.object({
  name: z.string().min(1).max(120).trim(),
  slug: slugSchema.optional(),
  parentId: z.string().uuid().nullable().optional(),
  description: z.string().max(4000).default(''),
  imageMediaId: z.string().uuid().nullable().optional(),
  heroBannerId: z.string().uuid().nullable().optional(),
  position: z.number().int().min(0).default(0),
  isActive: z.boolean().default(true),
  seo: seoSchema.optional(),
  // Category-specific customer experience hints (spec section 17)
  experienceTemplate: z
    .enum(['default', '3d_printing', 'diy_kids', 'moulds', 'candles', 'custom_orders'])
    .default('default'),
});

export const collectionInputSchema = z.object({
  name: z.string().min(1).max(120).trim(),
  slug: slugSchema.optional(),
  description: z.string().max(4000).default(''),
  imageMediaId: z.string().uuid().nullable().optional(),
  // Manual assortment or rule-based (spec section 3 homepage modules)
  mode: z.enum(['manual', 'rule']).default('manual'),
  rule: z
    .object({
      productType: z.string().optional(),
      tag: z.string().optional(),
      categoryId: z.string().uuid().optional(),
      minPrice: z.number().int().optional(),
      maxPrice: z.number().int().optional(),
      newerThanDays: z.number().int().optional(),
    })
    .optional(),
  productIds: z.array(z.string().uuid()).max(500).default([]),
  isActive: z.boolean().default(true),
  seo: seoSchema.optional(),
});

export type CategoryInput = z.infer<typeof categoryInputSchema>;
export type CollectionInput = z.infer<typeof collectionInputSchema>;
